import { createSlice } from "@reduxjs/toolkit";

export const carSlice = createSlice({
  name: "car",
  initialState: {
    cars: [],
    selectedCar: { brand: null, model: null, year: null, carDetails: null },
  },

  reducers: {
    setCars: (state, action) => {
      return { ...state, cars: action.payload };
    },
    setCarBrand: (state, action) => {
      return {
        ...state,
        selectedCar: {
          brand: action.payload,
          model: null,
          year: null,
          carDetails: null,
        },
      };
    },
    setCarModel: (state, action) => {
      return {
        ...state,
        selectedCar: {
          ...state.selectedCar,
          model: action.payload,
          year: null,
          carDetails: null,
        },
      };
    },
    setCarYear: (state, action) => {
      return {
        ...state,
        selectedCar: {
          ...state.selectedCar,
          year: action.payload,
          carDetails: null,
        },
      };
    },
    setCarDetails: (state, action) => {
      return {
        ...state,
        selectedCar: { ...state.selectedCar, carDetails: action.payload },
      };
    },
    resetCar: (state) => {
      return {
        ...state,
        selectedCar: { brand: null, model: null, year: null, carDetails: null },
      };
    },
  },
});

// action creators
export const {
  setCars,
  setCarBrand,
  setCarModel,
  setCarYear,
  setCarDetails,
  resetCar,
} = carSlice.actions;

export default carSlice.reducer;
